module.exports = __webpack_public_path__ + "up_arrow_icon.5cb85a33.png";